import React from 'react'
import moment from 'moment'

export const Footer = () => {
    return (
        <div className="page-footer">
            <div className="row">
                <div className="col-md-12">
                    <span className="footer-text">{moment().format('YYYY')} © Skyfest</span>
                </div>
            </div>
        </div>
    )
}
